"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayCalendar = void 0;
const luxon_1 = require("luxon");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const fetchUtils_1 = require("../../client/fetchUtils");
const paths_1 = require("../../paths");
const EventEmitter_1 = require("../../utils/EventEmitter");
const taaConfigs_1 = require("../../contexts/taaConfigs");
function usePayCalendar({ employeeId, timeRange, usageLocation }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const host = fetchUtils_1.essPortalUrl[currentStage];
    const path = (0, paths_1.GET_PAY_PERIOD_CALENDAR_API)(luxon_1.DateTime.fromISO(timeRange.start).toISODate(), luxon_1.DateTime.fromISO(timeRange.end).toISODate());
    const { isLoading, data: rawResponse } = (0, react_query_1.useQuery)(['payCalendar', path], () => (0, fetchClient_1.getData)({
        path,
        host,
        eventName: EventEmitter_1.taaEvents.GET_PAY_PERIOD_CALENDAR,
        metaData: {
            apiName: 'getPayCalendar',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId,
        staleTime: 600 * 1000,
        retry: false
    });
    const getPayCalendarResponse = {
        payPeriodList: rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.pay_period_list.map((rawPayPeriod) => ({
            startDate: rawPayPeriod.start_date,
            endDate: rawPayPeriod.end_date,
            payDate: rawPayPeriod.pay_date
        }))
    };
    return { isLoading, payCalendar: getPayCalendarResponse };
}
exports.usePayCalendar = usePayCalendar;
